import * as React from "react";
import classnames from "classnames";
/* empty css                              */
const StoreFinderClickableItem = ({
  className,
  variant,
  children,
  disabled = false,
  icon,
  type = "button",
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      ...rest,
      type,
      disabled,
      className: classnames("stores-v2-store-finder-item", className, {
        "stores-v2-store-finder-item--list-item": variant === "list-item",
        "stores-v2-store-finder-item--map-item": variant === "map-item",
        "stores-v2-store-finder-item--disabled": disabled
      })
    },
    icon ? /* @__PURE__ */ React.createElement("div", { className: "stores-v2-store-finder-item__icon" }, icon) : null,
    children
  );
};
export {
  StoreFinderClickableItem as default
};
//# sourceMappingURL=StoreFinderClickableItem.js.map
